module.exports = __webpack_public_path__ + "img/symbol_2.a7a22bb3.png";